import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SafePipe } from 'src/app/helpers/SafePipe';
import Swal from 'sweetalert2';
import { PaymentConfirmationComponent } from 'src/app/shared/check-out/payment-confirmation/payment-confirmation.component';
import { MatDialog } from '@angular/material/dialog';
import { NgIf } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ResAnonymousService } from '../service/ResAnonymous.service';

class validateRes {
  errorMsg!: string;
  status!: ValidateStatus;
}
enum ValidateStatus {
  Valid = 'Valid', NotValid = 'NotValid', Success = 'Success'
}
@Component({
  selector: 'app-client-pay',
  standalone: true,
  imports: [SafePipe, TranslateModule, NgIf, MatProgressSpinnerModule],
  templateUrl: './client-pay.component.html'
})
export class ClientPayComponent implements OnInit {
  referencePaymentUrl = `./assets/paymentWidget.html${location.search}`;
  checkoutId!: string;
  type!: string;
  loading = false;
  validateRes!: validateRes;
  constructor(
    private activatedRoute: ActivatedRoute,
    private service: ResAnonymousService,
    private translate: TranslateService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.activatedRoute.queryParamMap.subscribe(params => {
      if (params.get('id')) {
        this.checkoutId = params.get('id') || '';
      }
      if (params.get('checkoutId')) {
        this.checkoutId = params.get('checkoutId') || '';
      }
      if (params.get('Type')) {
        this.type = params.get('Type') || '';
      }
      if (this.checkoutId) {
        this.validateCheckOutId();
      }
    });
  }


  validateCheckOutId() {
    this.loading = true;
    this.service.ValidateAnonymousCheckOutId(this.checkoutId, this.type)
      .subscribe(resp => {
        this.loading = false;
        this.validateRes = resp as validateRes;
        if (this.validateRes?.status == ValidateStatus.NotValid) {
          this.doFailAlert(this.validateRes.errorMsg);
        }
        if (this.validateRes?.status == ValidateStatus.Success) {
          this.paymentConfirmation();
        }
    }, err => {
        this.loading = false;
        this.doFailAlert();
      });
  }

  doFailAlert(text: string = '') {
    Swal.fire({
      title: this.translate.instant('swalMsg.Failed'),
      text,
      icon: 'error',
      confirmButtonText: this.translate.instant('swalMsg.Ok'),
    }).then(() => {
      window.location.href = window.location.origin + '/404'
    });
  }
  paymentConfirmation() {
    const dialogRef = this.dialog.open(PaymentConfirmationComponent, {
      width: '50rem',
      data: { type: 'doneClient' }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }
}
